import { FC } from 'react'

type Props = {
  className?: string
  width?: string | number
  height?: string | number
  circle?: boolean
}

export const Skeleton: FC<Props> = ({ className = '', width, height, circle }) => {
  const style: React.CSSProperties = {
    width: width,
    height: height,
    borderRadius: circle ? '50%' : '0.5rem',
  }

  return (
    <div
      className={`animate-pulse bg-gray-200 ${className}`}
      style={style}
    ></div>
  )
}

export const ApplicationCardSkeleton = () => (
  <div className='p-4 border-b border-gray-100 flex items-start gap-4'>
    <Skeleton circle width={48} height={48} className='flex-shrink-0' />
    <div className='flex-1'>
      <div className='flex justify-between items-center mb-2'>
        <Skeleton width='60%' height={16} />
        <Skeleton width={16} height={16} />
      </div>
      <Skeleton width='40%' height={12} className='mb-2' />
      <Skeleton width={60} height={18} />
    </div>
  </div>
)

export const ApplicationDetailSkeleton = () => (
  <div className='flex flex-col h-full bg-white'>
    <div className='p-6 border-b border-gray-200'>
      <div className='flex justify-between items-start mb-6'>
        <div className='flex-1'>
          <Skeleton width='40%' height={32} className='mb-2' />
          <Skeleton width='30%' height={20} />
        </div>
        <div className='flex gap-2'>
          <Skeleton width={100} height={40} />
          <Skeleton width={100} height={40} />
        </div>
      </div>
      <div className='flex gap-6'>
        <Skeleton width={150} height={20} />
        <Skeleton width={150} height={20} />
      </div>
    </div>
    <div className='p-6'>
      <div className='space-y-6'>
        <Skeleton width='20%' height={24} className='mb-4' />
        <div className='grid grid-cols-2 gap-6'>
          {[1, 2, 3, 4, 5, 6].map(i => (
            <div key={i} className='space-y-2'>
              <Skeleton width='30%' height={14} />
              <Skeleton width='80%' height={18} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
)
